<div class="tab-box">
  <div
    *ngFor="let tab of tabs; let i = index"
    class="tab-list"
    [class.active]="i === activeIndex"
    (click)="onTabClick(i)"
  >
    <i [class]="tab.icon" class="tab-icon"></i>
    <h3 class="tab-label" [attr.data-translate]="tab.label"></h3>
  </div>
</div>

<div class="tab-wrapper">
  <div
    class="tab-grid experience"
    [class.active]="activeIndex === 0"
    appHideShellOnScroll
    [scrollKey]="scrollPrefix + '-experience'"
    [hideNav]="false"
    [hideDock]="true"
    [hideFooter]="false"
  >
    <div
      *ngFor="let job of tabContent.experience; let i = index"
      class="tab-item"
    >
      <h4 [attr.data-translate]="'RESUME.CONTENT.EXPERIENCE.' + i + '.YEARS'"></h4>
      <h4 [attr.data-translate]="'RESUME.CONTENT.EXPERIENCE.' + i + '.POSITION'"></h4>
      <h4 [attr.data-translate]="'RESUME.CONTENT.EXPERIENCE.' + i + '.COMPANY'"></h4>
      <p [attr.data-translate]="'RESUME.CONTENT.EXPERIENCE.' + i + '.DESCRIPTION'"></p>
    </div>
  </div>

  <div
    class="tab-grid skills"
    [class.active]="activeIndex === 1"
    appHideShellOnScroll
    [scrollKey]="scrollPrefix + '-skills'"
    [hideNav]="false"
    [hideDock]="true"
    [hideFooter]="false"
  >
    <div
      *ngFor="let skill of tabContent.skills; let i = index"
      class="tab-item"
    >
      <i [class]="skill.ICON"></i>
      <p [attr.data-translate]="'RESUME.CONTENT.SKILLS.' + i + '.NAME'"></p>
    </div>
  </div>

  <div
    class="tab-grid education"
    [class.active]="activeIndex === 2"
    appHideShellOnScroll
    [scrollKey]="scrollPrefix + '-education'"
    [hideNav]="false"
    [hideDock]="true"
    [hideFooter]="false"
  >
    <div
      *ngFor="let edu of tabContent.education; let i = index"
      class="tab-item"
    >
      <h4 [attr.data-translate]="'RESUME.CONTENT.EDUCATION.' + i + '.DEGREE'"></h4>
      <h4 [attr.data-translate]="'RESUME.CONTENT.EDUCATION.' + i + '.INSTITUTION'"></h4>
      <h4 [attr.data-translate]="'RESUME.CONTENT.EDUCATION.' + i + '.YEAR'"></h4>
      <p [attr.data-translate]="'RESUME.CONTENT.EDUCATION.' + i + '.DESCRIPTION'"></p>
    </div>
  </div>
</div>
